<mat-spinner *ngIf="loading$ | async" [diameter]="32"></mat-spinner>
<ng-container *ngIf="billingDetails$ | async as billingData">
  <form *ngIf="(loading$ | async) === false" [formGroup]="billingForm">
    <div class="radio__container" fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
      <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Billing type</strong>
      <div fxFlex="300px" fxFlex.lt-md="none">
        <mat-radio-group formControlName="business">
          <mat-radio-button [value]="true">Business</mat-radio-button>
          <mat-radio-button [value]="false">Personal</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div
      *ngIf="billingForm.get('business').value"
      fxLayout
      fxLayoutAlign="start top"
      fxLayout.lt-md="column"
      fxLayoutGap.lt-md="8px">
      <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Company name</strong>
      <div fxFlex="300px" fxFlex.lt-md="none">
        <mat-form-field class="input__mini fw">
          <input matInput formControlName="companyName" maxlength="64" />
          <mat-error *ngIf="billingForm.get('companyName').hasError('required')">
            Company name is required for businesses
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div
      *ngIf="billingForm.get('business').value && (showVatField$ | async)"
      fxLayout
      fxLayoutAlign="start top"
      fxLayout.lt-md="column"
      fxLayoutGap.lt-md="8px">
      <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">VAT</strong>
      <div fxFlex="300px" fxFlex.lt-md="none">
        <mat-form-field class="input__mini fw">
          <input matInput formControlName="vat" maxlength="32" />
        </mat-form-field>
      </div>
    </div>

    <div
      *ngIf="billingForm.get('business').value && (showTaxIdField$ | async)"
      fxLayout
      fxLayoutAlign="start top"
      fxLayout.lt-md="column"
      fxLayoutGap.lt-md="8px">
      <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Tax ID</strong>
      <div fxFlex="300px" fxFlex.lt-md="none">
        <mat-form-field class="input__mini fw">
          <input
            matInput
            formControlName="taxId"
            maxlength="64"
            placeholder="National tax ID to be included in invoices" />
        </mat-form-field>
      </div>
    </div>

    <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
      <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Address line 1</strong>
      <div fxFlex="300px" fxFlex.lt-md="none">
        <mat-form-field class="input__mini fw">
          <input
            matInput
            formControlName="street1"
            maxlength="64"
            placeholder="Address line 1"
            sbnbGooglePlaces
            (placeChanged)="onPlaceChanged($event)"
            data-address-input />
          <mat-error *ngIf="billingForm.get('street1').hasError('required')">Address line 1 is required</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
      <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Address line 2</strong>
      <div fxFlex="300px" fxFlex.lt-md="none">
        <mat-form-field class="input__mini fw">
          <input matInput formControlName="street2" maxlength="64" placeholder="Address line 2" />
        </mat-form-field>
      </div>
    </div>

    <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
      <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">City</strong>
      <div fxFlex="300px" fxFlex.lt-md="none">
        <mat-form-field class="input__mini fw">
          <input matInput formControlName="city" maxlength="64" placeholder="City" />
          <mat-error *ngIf="billingForm.get('city').hasError('required')">City is required</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
      <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">State/Region</strong>
      <div fxFlex="300px" fxFlex.lt-md="none">
        <mat-form-field class="input__mini fw">
          <input matInput formControlName="region" maxlength="64" placeholder="State/Region" />
          <mat-error *ngIf="billingForm.get('region').hasError('required')">State/Region is required</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
      <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Postal code</strong>
      <div fxFlex="300px" fxFlex.lt-md="none">
        <mat-form-field class="input__mini fw">
          <input matInput formControlName="postcode" maxlength="64" placeholder="Zip code" />
          <mat-error *ngIf="billingForm.get('postcode').hasError('required')">Postcode is required</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
      <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Country</strong>
      <div fxFlex="300px" fxFlex.lt-md="none">
        <mat-form-field *ngIf="countries && countries.length > 0" class="input__mini fw">
          <input matInput formControlName="country" [matAutocomplete]="auto" placeholder="Country" />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let country of filteredCountries | async" [value]="country.name">
              {{ country.name }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="billingForm.get('country').hasError('invalidCountry')">
            Please select a valid country
          </mat-error>
        </mat-form-field>

        <button
          [disabled]="saving || !billingForm.valid"
          type="submit"
          class="save__button"
          mat-flat-button
          (click)="save()">
          {{ embedded ? 'Continue' : 'Save changes' }}
          <mat-spinner *ngIf="saving" class="button__spinner" diameter="30"></mat-spinner>
        </button>
      </div>
    </div>
  </form>
</ng-container>
